"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadAction = exports.deleteAction = exports["default"] = exports.ActionsContainer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HBMediaElement = _interopRequireDefault(require("../HBMediaElement/HBMediaElement"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBFilePreview = _interopRequireDefault(require("../HBFilePreview/HBFilePreview"));
var _image = require("../common/image.utils");
var _useWindowSize2 = require("../common/useWindowSize");
var _icons = require("@honeybook/icons");
var _HBMenu = _interopRequireDefault(require("../HBMenu/HBMenu"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBImageThumbnail = function HBImageThumbnail(_ref) {
  var image = _ref.image,
    _onDownload = _ref.onDownload,
    _onDelete = _ref.onDelete,
    onSelect = _ref.onSelect,
    actions = _ref.actions,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
    alt = _ref.alt,
    additionalInfo = _ref.additionalInfo;
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isMediumUp = _useWindowSize.isMediumUp;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isPreviewShown = _useState2[0],
    setIsPreviewShown = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isMenuOpen = _useState4[0],
    setIsMenuOpen = _useState4[1];
  var handleClick = function handleClick() {
    if (onSelect) {
      onSelect(image);
    } else {
      setIsPreviewShown(true);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(Container, {
    onClick: handleClick,
    testIdName: "image-thumbnail",
    shouldShowExpandedView: isMenuOpen
  }, /*#__PURE__*/_react["default"].createElement(ImageComponent, {
    image: image,
    lazyLoad: lazyLoad,
    alt: alt
  }), isMediumUp && /*#__PURE__*/_react["default"].createElement(ActionsContainer, null, /*#__PURE__*/_react["default"].createElement(MenuContainer, {
    targetAsChild: true,
    preventClickPropogation: true,
    testIdName: "actions",
    menuItems: actions.map(function (action) {
      return _objectSpread(_objectSpread({}, action), {}, {
        type: 'item',
        icon: /*#__PURE__*/_react["default"].createElement(action.icon, null),
        title: action.label
      });
    }),
    target: /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
      testIdName: "actions-menu",
      icon: _icons.DotsVertical16,
      label: "Actions"
    }),
    onOpenChange: function onOpenChange(isOpen) {
      return setIsMenuOpen(isOpen);
    }
  })), isMediumUp && /*#__PURE__*/_react["default"].createElement(InfoContainer, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "emphasis14",
    color: "white",
    ellipsis: true
  }, image.name), additionalInfo && /*#__PURE__*/_react["default"].createElement(AdditionalInfoContainer, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "emphasis12",
    color: "white",
    ellipsis: true
  }, additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.title), /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "emphasis12",
    color: "white",
    ellipsis: true
  }, additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.content))), isPreviewShown && /*#__PURE__*/_react["default"].createElement(_HBFilePreview["default"], {
    fileName: image.name,
    fileUrl: image.url,
    cloudinaryPublicId: image.cloudinary_public_id,
    fileType: "image",
    onClose: function onClose() {
      return setIsPreviewShown(false);
    },
    onDownload: function onDownload() {
      return _onDownload(image);
    },
    onDelete: function onDelete() {
      return _onDelete(image);
    }
  }));
};
var downloadAction = exports.downloadAction = {
  icon: _icons.Download16,
  label: 'Download',
  testIdName: 'download',
  onClick: function onClick() {},
  theme: 'default'
};
var deleteAction = exports.deleteAction = {
  icon: _icons.Trash16,
  label: 'Delete',
  testIdName: 'delete',
  onClick: function onClick() {},
  theme: 'destructive'
};
var ImageComponent = function ImageComponent(_ref2) {
  var image = _ref2.image,
    lazyLoad = _ref2.lazyLoad,
    alt = _ref2.alt;
  if (image.cloudinary_public_id || (0, _image.isCloudinaryImage)(image.url)) {
    return /*#__PURE__*/_react["default"].createElement(CloudinaryImage, {
      path: image.cloudinary_public_id || image.url,
      height: "120",
      crop: "fill",
      lazyLoad: lazyLoad,
      alt: alt
    });
  } else if (image.url) {
    return /*#__PURE__*/_react["default"].createElement(S3Image, {
      src: image.url,
      alt: image.name
    });
  } else if (image.dataUrl) {
    return /*#__PURE__*/_react["default"].createElement(ImageDuringUpload, {
      src: image.dataUrl,
      alt: image.name
    });
  }
};
var _default = exports["default"] = HBImageThumbnail;
var InfoContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBImageThumbnail__InfoContainer",
  componentId: "sc-1vs0pv3-0"
})(["display:flex;flex-direction:column;opacity:0;background:linear-gradient( 0deg,rgba(19,20,22,0.53) 0%,rgba(58,61,67,0.56) 25.1%,rgba(107,113,124,0) 96.08% );padding:5px;position:absolute;bottom:0;left:0;width:100%;box-sizing:border-box;transition:opacity 0.2s ease;"]);
var AdditionalInfoContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBImageThumbnail__AdditionalInfoContainer",
  componentId: "sc-1vs0pv3-1"
})(["display:flex;flex-direction:column;"]);
var ActionsContainer = exports.ActionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBImageThumbnail__ActionsContainer",
  componentId: "sc-1vs0pv3-2"
})(["opacity:0;display:flex;position:absolute;top:8px;right:8px;width:30px;height:30px;border-radius:3px;background:", ";box-shadow:0 6px 16px 0 rgba(0,0,33,0.1),0 0 2px 1px rgba(0,0,33,0.05);transition:opacity 0.2s ease;"], _colors["default"].white);
var MenuContainer = (0, _styledComponents["default"])(_HBMenu["default"]).withConfig({
  displayName: "HBImageThumbnail__MenuContainer",
  componentId: "sc-1vs0pv3-3"
})(["&:hover ", "{opacity:1;}"], InfoContainer);
var Container = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBImageThumbnail__Container",
  componentId: "sc-1vs0pv3-4"
})(["height:120px;position:relative;display:inline-block;", " &:hover :is(", ",", "){opacity:1;}"], function (_ref3) {
  var shouldShowExpandedView = _ref3.shouldShowExpandedView;
  return shouldShowExpandedView && (0, _styledComponents.css)(["", ",", "{opacity:1;}"], ActionsContainer, InfoContainer);
}, ActionsContainer, InfoContainer);
var CloudinaryImage = (0, _styledComponents["default"])(_HBMediaElement["default"]).withConfig({
  displayName: "HBImageThumbnail__CloudinaryImage",
  componentId: "sc-1vs0pv3-5"
})(["min-width:100px;text-align:center;"]);
var S3Image = _styledComponents["default"].img.withConfig({
  displayName: "HBImageThumbnail__S3Image",
  componentId: "sc-1vs0pv3-6"
})(["height:120px;min-width:100px;object-fit:contain;"]);
var ImageDuringUpload = (0, _styledComponents["default"])(S3Image).withConfig({
  displayName: "HBImageThumbnail__ImageDuringUpload",
  componentId: "sc-1vs0pv3-7"
})(["opacity:0.4;"]);
//# sourceMappingURL=HBImageThumbnail.js.map